export class ProductCode {
  public static Premium = ['PremiumA', 'PremiumB', 'PremiumC'];
}
